import ImageCard from '../ImageCard';
import {useTranslation} from 'react-i18next';
import {ILocation} from '../../types/resources/Location';
import React from 'react';
import styled from 'styled-components';
import DateUtils from '../../utils/DateUtils';
import LocationUtils from '../../utils/LocationUtils';

const Content = styled.div`
  align-items: flex-start;
`

const Table = styled.table`
    //width: min-content;
`

const Heading = styled.th.attrs({
    className: 'cr-bold cr-pr-xl cr-pb',
})`
    text-align: left;
`

type TProps = {
    location: ILocation;
}

const LocationCard = ({location}: TProps) => {
    const {t} = useTranslation();

    const date = location.startDateTime ? DateUtils.getHumanDate(location.startDateTime) : null;
    const time = location.startDateTime ? DateUtils.getHumanTime(location.startDateTime) : null;

    const Container: React.FC<{ location: ILocation; children: React.ReactNode }> = ({location, children}) => {
        return location.imageUrl ? (
            <ImageCard
                imageSrc={location.imageUrl}
                imageAlt={location.name ?? ''}
            >
                {children}
            </ImageCard>
        ) : (
            <div className="cr-image-card cr-flex cr-flex-col cr-bg-grey-light cr-shadow cr-rounded-block cr-h-100">
                {children}
            </div>
        );
    }

    // location.imageUrl = 'https://www.vdstappen.nl/wp-content/uploads/2021/11/uitvaart-van-een-kindje-min.jpg';

    return (
        <Container location={location}>
            <Content className="cr-p-lg cr-flex cr-flex-col cr-flex-1 cr-gap-sm cr-text-secondary">
                <div>
                    <div>{location.typeDescription}</div>
                    <div className="cr-bold cr-text-alert cr-text-lg">
                        {location.name}
                    </div>
                </div>
                {(date || time) &&
                    <Table>
                        <tbody>
                        {date &&
                            <tr>
                                <Heading>{t('date')}</Heading>
                                <td>{date}</td>
                            </tr>
                        }
                        {time &&
                            <tr>
                                <Heading>{t('time')}</Heading>
                                <td>{time}</td>
                            </tr>
                        }
                        </tbody>
                    </Table>
                }
                {location.address &&
                    <div>{location.address}</div>
                }
                {location.website &&
                    <a href={location.website} target="_blank" rel="noreferrer">{location.website}</a>
                }
                {location.address &&
                    <div className={'cr-mt-auto cr-flex'}>
                        <a
                            className="cr-pill cr-bg-alert cr-text-white cr-my-xl"
                            href={LocationUtils.generateRouteUrl(location.address)} target="_blank" rel="noreferrer"
                        >
                            {t('plan-route')}
                        </a>
                    </div>
                }
            </Content>
        </Container>
    );
}

export default LocationCard;
